import { useEffect } from "react"
import { useDispatch } from "react-redux"
import Echo from "laravel-echo"
import Pusher from "pusher-js"
import { actions as dataActions } from "../store/data/data.reducers"
import toastService from "../services/toastService"

window.Pusher = Pusher

const echo = new Echo({
  broadcaster: "reverb",
  // eslint-disable-next-line no-undef
  key: process.env.REACT_APP_REVERB_APP_KEY,
  // eslint-disable-next-line no-undef
  wsHost: process.env.REACT_APP_REVERB_HOST,
  // eslint-disable-next-line no-undef
  wsPort: process.env.REACT_APP_REVERB_PORT ?? 80,
  // eslint-disable-next-line no-undef
  wssPort: process.env.REACT_APP_REVERB_PORT ?? 443,
  // eslint-disable-next-line no-undef
  forceTLS: (process.env.REACT_APP_REVERB_SCHEME ?? "https") === "https",
  enabledTransports: ["ws", "wss"]
})

export const useWebSocket = (user, isProcessPayrollStarted) => {
  const dispatch = useDispatch()
  // eslint-disable-next-line no-undef
  Pusher.logToConsole = process.env.NODE_ENV !== "production"

  useEffect(() => {
    if (echo && isProcessPayrollStarted && Object.keys(user).length) {
      const organizationID = user.organization_id

      // Create WebSocket channels specific to the organization
      const failedChannel = echo.channel(
        `paychex.organization.${organizationID}.process_payroll_failed`
      )
      const successChannel = echo.channel(`paychex.organization.${organizationID}.process_payroll`)

      // Listen for payroll processing failure events
      failedChannel.listen("PaychexPayrollProcessedFailed", () => {
        dispatch(dataActions.setIsProcessPayrollStarted(false))
        toastService.error("Paychex Process Payroll Failed. Please try again later")
      })

      // Listen for payroll processing success events
      successChannel.listen("PaychexPayrollProcessedSuccessfully", ({ has_unprocessed_companies, all_companies, processed_companies, unprocessed_companies }) => {
        dispatch(dataActions.setIsProcessPayrollStarted(false))

        if (processed_companies?.length > 0 && unprocessed_companies?.length === 0) {
          toastService.success('Process Payroll Completed')
        }

        if (processed_companies?.length > 0 && unprocessed_companies?.length > 0) {
          toastService.warning(`Process Payroll ${processed_companies.length}/${all_companies.length}. Please check notifications and try again later`)
        }

        if (processed_companies?.length === 0 && unprocessed_companies?.length > 0) {
          toastService.error('Process Payroll Failed. Please check notifications and try again later')
        }
      })

      // Clean up listeners when component is unmounted or dependencies change
      return () => {
        failedChannel.stopListening("PaychexPayrollProcessedFailed")
        successChannel.stopListening("PaychexPayrollProcessedSuccessfully")
      }
    }
  }, [echo, user.organization_id, isProcessPayrollStarted]) // Dependencies: reinitialize only when these values change

  return { echo }
}
